import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { filter, map } from '@beef/utils';
import { StylesDecorator } from "./StylesDecorator";
import { BuilderExtension } from "../BuilderExtension";
import { ChildUtils } from "../ChildUtils";
import { StylesProjection } from "./StylesProjection";
export var StylesExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(StylesExtension, _BuilderExtension);
  var _super = _createSuper(StylesExtension);
  function StylesExtension() {
    _classCallCheck(this, StylesExtension);
    return _super.apply(this, arguments);
  }
  _createClass(StylesExtension, [{
    key: "create",
    value: function create() {
      var _this = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new StylesDecorator(map(data, function (style) {
        return _this.next.create(style, params);
      }), params, new ChildUtils(this.next));
    }
  }, {
    key: "createProjection",
    value: function createProjection() {
      var _this2 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new StylesProjection(map(data, function (style) {
        return _this2.next.createProjection(style, params);
      }), params);
    }
  }, {
    key: "serialize",
    value: function serialize(cls) {
      var _this3 = this;
      // const result = filter(
      //   map(cls.value, (prop) => this.next.serialize(prop)),
      //   (style) => typeof style !== 'undefined',
      // ) as D;
      //
      // return Object.keys(result).length ? result : undefined;

      return filter(map(cls.value, function (prop) {
        return _this3.next.serialize(prop);
      }), function (style) {
        return typeof style !== 'undefined';
      });
    }
  }]);
  return StylesExtension;
}(BuilderExtension);